<template>
  <zm-dialog class="zoom-aic-plan-dialog" v-model="visible" show-close>
    <h1 class="zoom-aic-plan-dialog__title">
      {{ title }}
    </h1>
    <price-list
      class="zoom-aic-plan-dialog__price-list"
      :showDecimalPoint="is_desktop_reactive"
      :plan-category="planCategory"
      :unit-type="planUnitMap.user"
    />
    <ul class="zoom-aic-plan-dialog__desc">
      <li class="zoom-aic-plan-dialog__li" v-for="item in descList" :key="item">
        <img src="@/assets/plans/check.svg" alt="">
        <span>{{ item }}</span>
      </li>
    </ul>
  </zm-dialog>
</template>

<script>
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import PriceList from '@/components/price-list.vue';
import { planUnitMap } from '@/common/product-unit';

export default {
  name: 'ZoomAiCompanionPlanDetails',
  mixins: [ConfirmComponent],
  components: {
    PriceList,
  },
  props: {
    title: String,
    planCategory: String,
    planTrackingName: String,
  },
  data() {
    return {
      visible: false,
      planUnitMap,
      descList: [
        this.$t('billing.zoom_ai_companion.features_item1'),
        this.$t('billing.zoom_ai_companion.features_item2'),
        this.$t('billing.zoom_ai_companion.features_item3'),
        this.$t('billing.zoom_ai_companion.features_item4'),
        this.$t('billing.zoom_ai_companion.features_item5'),
        this.$t('billing.zoom_ai_companion.features_item6'),
        this.$t('billing.zoom_ai_companion.features_item7')
      ],
    };
  },
  watch: {
    /**
     * watch visible and fire event
     * @param {boolean} val visible
     */
    visible(val) {
      this.$tracking.buyInteraction(
        'plan details',
        `${this.planTrackingName} plan details - ${val ? 'impression' : 'exit'}`,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@zoom/billing-responsive/styles/responsive.scss';
@import "@/styles/variables.scss";

.zoom-aic-plan-dialog {
  :deep .zbo-dialog {
    padding: 72px 60px;
    min-width: 576px;
    width: fit-content;
    &__header {
      padding-bottom: 0;
    }
  }
  &__title {
    color: $zoom-color-text-stronger-neutral;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.5em;
  }

  &__price-list {
    margin-bottom: 4px;
    padding: 8px 0;
    @include media(mobile, tablet) {
      margin-top: 4px;
    }
  }

  &__desc {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5em;
    > li {
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  &__li {
    display: flex;
    gap: 8px;
  }
}
</style>
